<template>
    <div class="user">
        <div class="condition">
            <div class="item">
                <div class="label">账号:</div>
                <el-input v-model="conditionData.account" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">城市:</div>
                <el-input v-model="conditionData.city_name" size="small" placeholder="请输入"></el-input>
            </div>
            
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isImportDialog=true">导入数据</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="account"
                label="账号"
                align="center"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="isJUser"
                label="是否真实用户"
                align="center"
                width="110px"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isJUser">真实用户</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                prop="nickname"
                label="用户昵称"
                align="center"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.nickname }}</span>
                        <!-- <span v-if="scope.row.isJUser">(*)</span>
                        <span v-else></span> -->
                    </template>
                </el-table-column>
                <el-table-column
                prop="age"
                label="年龄"
                align="center"
                width="70"
                >
                </el-table-column>
                <el-table-column
                prop="sex"
                label="性别"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="weight"
                label="体重"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="wechat"
                label="微信"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="city_name"
                label="城市"
                align="center"
                >
                </el-table-column>
               
                <el-table-column
                fixed="right"
                label="操作"
                width="120px"
                align="center"
                >
                <template slot-scope="scope">
                    
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


      

        <el-dialog :close-on-click-modal="false" :visible.sync="isImportDialog" title="导入数据" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        数据
                    </div>
                    <div class="valuet">
                        <el-input v-model="importData" size="small" placeholder="请输入" type="textarea" rows="5"></el-input>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="AdminStandAddTanGuo()">确认</el-button>
                </div>
            </div>
            
        </el-dialog>

        

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
        
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS} from '../../../utils/index'
import {genderList,vipList,shenHeList,enableList} from '../../../assets/selectList/anxin'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'user',
    data () {
        return {
            vipList:vipList,
            enableList:enableList,
            genderList:genderList,
            shenHeList:shenHeList,
            isShow:false,
            totalCount:0,
            isDetailDialog:false,
            detailData:{},
            piclist:[],
            conditionData:{
                
                page:1,
                pageSize:10,
            },
            tableData:[],
           

            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,
            userId:'',
            // 解锁次数
            isSetUnlockNumber:false,
            setUnlockNumberData:{},
            // 会员设置
            isVip:false,
            vipData:{},
            // 动态次数
            isDynamicNumberDialog:false,
            dynamicNumberData:{},

            frozenData:{
                "userId": null,
                "reason": ""
            },
            isFrozenDialog:false,
            username:'',
            thawData:{
                "userId": null,
                "reason": ""
            },
            isThawDialog:false,

            isJinBiDialog:false,
            JinBiData:{
                "userId": null,
                "jinBi": 0
            },
            isEditDialog:false,
            editData:{
                "id": 0,
                "userId": 0,
                "nickName": "",
                "age": 0,
                "gender": 1,
                "city": "",
                "birthday": "",
                "shenGao": "",
                "tiZhong": "",
                "zhiYe": "",
                "love": "",
                "header": "",
                "lng": 0,
                "lat": 0,
                "address": "",
                "weChat": "",
                "unlockNumber": 0
            },

            isImportDialog:false,
            importData:'',
        }
    },
    components:{
        ElImageViewer
    },
    created(){

    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.AdminStandQueryPager(this.conditionData);
            console.log(res.data.data);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            for(let index in this.tableData){
                this.tableData[index].Time = parseTimeS(this.tableData[index].Time);
            }
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 重置
        reset(){
            this.conditionData = {
                
                page: 1,
                pageSize: 10,
            },
            this.loadingData();
        },
        async AdminStandAddTanGuo(){
            let res = await api.AdminStandAddTanGuo(JSON.parse(this.importData));
            console.log('AdminStandAddTanGuo');
            console.log(res);
            if(res.data.code){
                this.importData = '';
                this.$message({
                    type: 'success',
                    message: '导入成功!'
                });
                this.loadingData();
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            padding: 5px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        
        /deep/.table-expand {
            font-size: 0;
        }
        .row{
            display: flex;
        }
        /deep/.table-expand label {
            width: 150px;
            padding-left: 50px;
            color: #99a9bf;
        }
        /deep/.table-expand span {
            color: #222222;
        }
        /deep/.table-expand .btn span{
            color: #409eff;
        }
        /deep/.table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 450px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .valuet{
                width: 450px;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            margin-top: 10px;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
